import { render, staticRenderFns } from "./SideLinks.vue?vue&type=template&id=1d94e882"
import script from "./SideLinks.vue?vue&type=script&lang=js"
export * from "./SideLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports